module.exports = __webpack_public_path__ + "static/media/logo_condutor_legal.8a2d003e.png";